export const GET_USER_ACTIVITY_EVENTS_START = 'GET_USER_ACTIVITY_EVENTS_START';
export const GET_USER_ACTIVITY_EVENTS_SUCCESS = 'GET_USER_ACTIVITY_EVENTS_SUCCESS';
export const GET_USER_ACTIVITY_EVENTS_FAIL = 'GET_USER_ACTIVITY_EVENTS_FAIL';

export const GET_HUMAN_READABLE_EVENT_TYPES_START = 'GET_HUMAN_READABLE_EVENT_TYPES_START';
export const GET_HUMAN_READABLE_EVENT_TYPES_SUCCESS = 'GET_HUMAN_READABLE_EVENT_TYPES_SUCCESS';
export const GET_HUMAN_READABLE_EVENT_TYPES_FAIL = 'GET_HUMAN_READABLE_EVENT_TYPES_FAIL';
